import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-5" }
const _hoisted_2 = { class: "text-center text-xs font-medium text-gray-500" }
const _hoisted_3 = { class: "mt-1 text-center text-2xl font-semibold text-gray-800" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.metrics, ({ title, metric }) => {
      return (_openBlock(), _createBlock(_component_UiPanel, { key: title }, {
        default: _withCtx(() => [
          _createElementVNode("dt", _hoisted_2, _toDisplayString(title), 1 /* TEXT */),
          _createElementVNode("dd", _hoisted_3, _toDisplayString(metric), 1 /* TEXT */)
        ]),
        _: 2 /* DYNAMIC */
      }, 1024 /* DYNAMIC_SLOTS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}